import { Component } from '@angular/core';

import { App, NavController, ModalController, ViewController } from 'ionic-angular';

declare var dataLayer: Array<any>;

@Component({
  template: `
    <ion-list>
      <button ion-item (click)="close('http://www.voltio.com.au/energy-management/')">Learn About Voltio Energy Management Services</button>
      <button ion-item (click)="close('http://www.voltio.com.au/commercial-business-solar/')">Learn about Voltio Solar Solutions</button>
      <button ion-item (click)="support()">Support</button>
    </ion-list>
  `
})
export class PopoverPage {

  constructor(
    public viewCtrl: ViewController,
    public navCtrl: NavController,
    public app: App,
    public modalCtrl: ModalController
  ) { }

  support() {
    this.app.getRootNav().push('SupportPage');
    this.viewCtrl.dismiss();

    dataLayer.push({
      'appEventCategory': 'about-popover',
      'appEventAction': 'click',
      'appEventLabel': 'support button'
    });
    dataLayer.push({'event': 'appEvent'});
  }

  close(url: string) {
    window.open(url, '_blank');
    this.viewCtrl.dismiss();

    dataLayer.push({
      'appEventCategory': 'about-popover',
      'appEventAction': 'click',
      'appEventLabel': 'close button'
    });
    dataLayer.push({'event': 'appEvent'});
  }

  ionViewDidLoad() {
    dataLayer.push({
      'screenPath': 'about-popover',
      'screenName': 'PopoverPage'
    });
    dataLayer.push({'event': 'appScreenView'});
  }
}


// WEBPACK FOOTER //
// ./src/pages/about-popover/about-popover.ts